import { FC, ReactElement, useRef, useState, MouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../UI/Icon/Icon';
import AvisoArquivarObra from 'Pages/Obras/Modals/AvisoArquivarObra';
import { ObraActions } from 'Store/Obra/Obra.actions';
import { IArchivedStatusRequest } from 'Data/interfaces/Obra/IArchivedStatusRequest';
import AccessPermission from 'Utils/AcessPermission';
import { IContextMenuRef } from '../ContextMenu/model';
import ContextMenu from '../ContextMenu';
import { useQueryUpdateArchivedObra } from 'Hooks/obras/useQueryUpdateArchivedObra';
import { ContextMenuItem } from '../ContextMenu/styles';

interface IActionMenuItem {
  children: ReactElement;
  constructionSiteId: number;
  constructionSiteName?: string;
  activeObrasCount?: number;
  openInviteUser: () => void;
}

const ActionMenuItem: FC<IActionMenuItem> = ({
  constructionSiteId,
  children,
  constructionSiteName,
  activeObrasCount,
  openInviteUser,
}) => {
  const { t } = useTranslation('sharedModals');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { updateArchivedObra } = useQueryUpdateArchivedObra({
    dispatch,
    navigate
  });

  const contextMenuRef = useRef<IContextMenuRef>(null);
  const [arquivarObraVisible, setArquivarObraVisible] = useState(false);
  const menuId = `ActionMenuObra${constructionSiteId}`;

  const handleContextMenu = (e: MouseEvent) => {
    if (!AccessPermission.isAdmin() && !AccessPermission.isCoordenador()) {
      return;
    };

    contextMenuRef.current?.show(e);
  };

  const arquivarObra = () => {
    const status: IArchivedStatusRequest = {
      ConstructionSiteId: constructionSiteId,
      isArchived: true,
    };
    updateArchivedObra(status);
    if (activeObrasCount && activeObrasCount === 1) {
      dispatch(ObraActions.clearConstructionSiteSearch(true));
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div onContextMenu={handleContextMenu}>
        {children}
      </div>

      <ContextMenu ref={contextMenuRef} id={menuId} menuHeight={80} menuWidth={156.27}>
        <ContextMenuItem onClick={openInviteUser}>
          <Icon icon='adicionarUsuario' customColor='#44566C' size='xs' />
          <span>{t('actionMenu.addCollaborator')}</span>
        </ContextMenuItem>
        <ContextMenuItem onClick={() => setArquivarObraVisible(true)}>
          <Icon icon='arquivar' customColor='#44566C' size='xs' />
          <span>{t('actionMenu.archive')}</span>
        </ContextMenuItem>
      </ContextMenu>

      <AvisoArquivarObra
        nomeObra={constructionSiteName}
        visible={arquivarObraVisible}
        onCancel={() => setArquivarObraVisible(false)}
        onConfirm={arquivarObra}
      />
    </div>
  );
};

export default ActionMenuItem;
